import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { AppContext, ViewModel, CommandContext, Entity, FrameContext } from '@farris/devkit';
import { BefRepository } from '@farris/bef';

/**
 * å½ä»¤æå¡
 * @scope FrameConmponent
 */
@Injectable()
class CommandService {

  /**
   * åé¨cotnext
   */
  private innerContext: CommandContext;

  /**
   * contextåå¼æ¹æ³
   */
  public get context(): CommandContext {
    return this.innerContext;
  }

  /**
   * contextè®¾å¼æ¹æ³
   */
  public set context(context: CommandContext) {
    this.innerContext = context;
  }

  constructor(
    private viewModel: ViewModel,
    private appContext: AppContext
  ) { }

  /**
   * æ§è¡å½ä»¤
   * @param commandName å½ä»¤åç§°
   * @param frameId æ¡æ¶ID
   */
  public execute(commandName: string, frameId?: string): Observable<any> {
    if (!commandName || commandName === '' || commandName === 'undefined') {
      return;
    }
    let viewModel = this.viewModel;
    if (frameId) {
      const targetContext = this.appContext.frameContextManager.getFrameContextById(frameId);
      viewModel = targetContext.viewModel;
    }
    return viewModel[commandName]();
  }

  /**
   * ç­å¾BeSessionåå»º
   * @returns ææ°åå»ºåºæ¥çBeSession
   */
  public waitForBeSession(): Observable<string> {
    const frameContext = this.context.frameContext;
    const befRepository = frameContext.repository as BefRepository<Entity>;
    const sessionService = befRepository.restService.sessionService;
    return sessionService.getBeSessionId().pipe(
      filter((beSessionId: string) => {
        return beSessionId !== null;
      }),
      take(1)
    );
  }

  /**
   * æåæä¸ªä»»å¡çæ§è¡ç»æ
   * @param taskName ä»»å¡åç§°
   * @reutrn è¿åtaskNameå¯¹åºä»»å¡çæ§è¡ç»æ
   */
  public extractResult(taskName: string) {
    const results = this.context.results;
    return results[taskName];
  }
  /**
   * æåå½åç»ä»¶çè¡åæ¢äºä»¶æåº
   */
  public suspendFrameContextRowSelectedEvent(frameId?: string) {
    let frameContext: FrameContext = this.viewModel.frameContext;
    if (frameId) {
      frameContext = this.viewModel.frameContext.appContext.frameContextManager.getFrameContextById(frameId);
    }
    if (frameContext) {
      frameContext.bindingData.rowSelectedEventSuspend = true;
    }

  }
  public resumeFrameContextRowSelectedEvent(frameId?: string) {
    let frameContext: FrameContext = this.viewModel.frameContext;
    if (frameId) {
      frameContext = this.viewModel.frameContext.appContext.frameContextManager.getFrameContextById(frameId);
    }
    if (frameContext) {
      frameContext.bindingData.rowSelectedEventSuspend = false;
    }
  }
}

export { CommandService };
